export const FILTER_OPTIONS = [{ label: "Search by Name", value: "NAME" }, { label: "Search by Tax Id", value: "TAX_ID" }]

export const PAYER_DROPDOWN_LOADING_STATES = {
    GET_PAGINATED_PAYER_LIST_LOADING: "GET_PAGINATED_PAYER_LIST_LOADING",
    GET_PAGINATED_PAYER_LIST_READY: "GET_PAGINATED_PAYER_LIST_READY"
}

export const PAYER_DROPDOWN_MESSAGE_MAP = {
    [PAYER_DROPDOWN_LOADING_STATES.GET_PAGINATED_PAYER_LIST_LOADING]: "Fetching Payers List"
}